import { render, staticRenderFns } from "./SocialAccountLogin.vue?vue&type=template&id=14856f26&"
import script from "./SocialAccountLogin.vue?vue&type=script&lang=ts&"
export * from "./SocialAccountLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports